import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import dayjs from 'dayjs'
import MarginWrapper from '../../features/wrappers/MarginWrapper'
import isMobileView from '../../util/MobileView'
import SecurityMobile from './SecurityMobile'
import SecurityDesktop from './SecurityDesktop'

import {
  setLastRequest,
  fetchLoginHistory,
  getLoginHistoryFilter,
  getLoginHistoryPagination,
  setStartDate, setEndDate
} from '../../features/user/LoginHistorySlice'

const defaultStartDate = new Date()
defaultStartDate.setMonth(defaultStartDate.getMonth() - 1)

const DEFAULT_START_DATE = defaultStartDate.toISOString().replace(/\.\d{3}Z$/, 'Z')
const toIsoNoMs = (date) => {
  try {
    return new Date(date).toISOString().replace(/\.\d{3}Z$/, 'Z')
  } catch (error) {
    return null
  }
}

export function Security() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { page, rowsPerPage } = useSelector(getLoginHistoryPagination)
  const { startDate, endDate } = useSelector(getLoginHistoryFilter)
  const lastRequest = useSelector(
    (state) => state.loginHistory.lastRequest
  )

  useEffect(() => {
    // Set defaults
    if (!startDate && !endDate) {
      const now = new Date()
      const startIso = DEFAULT_START_DATE
      const endDateIso = toIsoNoMs(now)

      dispatch(setStartDate(dayjs(startIso)))
      dispatch(setEndDate(dayjs(endDateIso)))
    }
  }, [])

  useEffect(() => {
    const now = new Date()

    const startIso = startDate
      ? toIsoNoMs(dayjs(startDate).startOf('day').toDate())
      : DEFAULT_START_DATE

    let endBase
    if (endDate) {
      const picked = dayjs(endDate)
      endBase = picked.isSame(dayjs(), 'day')
        ? now
        : picked.endOf('day').toDate()
    } else {
      endBase = now
    }

    const startObj = new Date(startIso)
    if (endBase < startObj) endBase = startObj
    const EndDate = toIsoNoMs(endBase)
    const params = {
      pageSize: rowsPerPage,
      pageOffset: page,
      startDate: startIso,
      endDate: EndDate,
    }

    const requestKey = {
      page,
      rowsPerPage,
      startDate: startDate ?? null,
      endDate: endDate ?? null
    }
    const sameRequest = JSON.stringify(lastRequest) === JSON.stringify(requestKey)

    if (!sameRequest) {
      dispatch(setLastRequest(requestKey))
      dispatch(fetchLoginHistory(params))
    }
  }, [page, rowsPerPage, startDate, endDate, dispatch])

  return (
    <MarginWrapper>
      {isMobileView() ? (
        <div>
          <SecurityMobile
            t={t}
          />
        </div>

      ) : (
        <SecurityDesktop
          t={t}
        />
      )}
    </MarginWrapper>
  )
}

export default Security
